import { render, staticRenderFns } from "./Step5_ExtraItems.vue?vue&type=template&id=62802f87"
import script from "./Step5_ExtraItems.vue?vue&type=script&lang=js"
export * from "./Step5_ExtraItems.vue?vue&type=script&lang=js"
import style0 from "./Step5_ExtraItems.vue?vue&type=style&index=0&id=62802f87&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports